window.BOL = window.BOL || {};
window.BOL.myProduct = window.BOL.myProduct || {};
window.BOL.RegisterProduct = window.BOL.RegisterProduct || {};
window.BOL.Account = window.BOL.Account || {};
window.BOL.Checkout = window.BOL.Checkout || {};
